/** @jsx jsx */
import { jsx } from 'theme-ui';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Box } from '@chakra-ui/core';

export const ParticipantInfo = (): JSX.Element => {
  return <Box />;
};
